import React from 'react';
import { equals } from 'ramda';
import { ROLES } from '../../../lib/rights';
import MenuAdminLayout from '../../../components/users/MenuAdminLayout';
import UsersList from '../../../components/users/UsersList';

const MyTeam = () => (
  <MenuAdminLayout
    title="Gérer les utilisateurs de mon équipe"
    description="Gérez par offre les utilisateurs et leurs rôles (éditeur, lecteur ou QA)"
  >      
    <UsersList
      type="team"
      itemDisabled={(role) => equals(role, ROLES.admin)}
    />
  </MenuAdminLayout>
);

export default MyTeam;
